import { blockCategories } from '../../categories';
import { registerNavigationItemsTrait } from './navigationItemsTrait';

const COMPONENT_TYPE = 'navigation-bar';
const BLOCK_ID = 'navigation-bar';
const PLACEHOLDER_LABEL = 'Navigation';

export default function navigationBar(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    registerNavigationItemsTrait(editor);

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-navigation-bar') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return {
                    type: COMPONENT_TYPE,
                };
            }
            return undefined;
        },

        model: {
            defaults: {
                tagName: 'div',
                name: 'Navigation',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-navigation-bar',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                navigationItems: [],
                traits: [
                    {
                        type: 'navigation-items',
                        name: 'navigationItems',
                        label: 'Navigationselemente',
                    },
                ],
            },
        },

        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Navigation',
        category: blockCategories.journeyDetail,
        media: `
            <svg viewBox="0 0 24 24">
                <path
                    fill="currentColor"
                    d="M3 6h18v2H3V6Zm0 5h18v2H3v-2Zm0 5h18v2H3v-2Z"
                />
            </svg>
        `,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-navigation-bar',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
            navigationItems: [],
        },
    });
}
